// Copyright (c) 2017 Deere & Company

/* eslint-disable complexity, max-params */

export const buildHighOnRentalDaysPayload = (facets, exportToExcel, language) => ({
    dealerIds: facets.dealer.accounts.selectedAccounts.map(dealer => dealer.account),
    export: exportToExcel,
    language
});

/* eslint-enable complexity, max-params */



// WEBPACK FOOTER //
// ./src/product/shared/services/build-high-rental-days-payload.js